const pause = (duration: number) => new Promise((res) => setTimeout(res, duration));

export function retryN<T = void>(
    func: () => Promise<T>,
    maxRetries: number,
    retryDelay: number,
    retryCondition?: () => boolean,
    logger?: (attempt: number) => void
): Promise<T> {
    const attempt = (remainingAttempts: number, totalAttempts: number): Promise<T> => {
        return func().catch((err) => {
            if (typeof retryCondition === 'function' && !retryCondition()) return Promise.reject(err);
            if (typeof logger === 'function') logger(totalAttempts - remainingAttempts + 1);
            if (remainingAttempts > 1)
                return pause(retryDelay).then(() => attempt(remainingAttempts - 1, totalAttempts));
            return Promise.reject(err);
        });
    };

    return attempt(maxRetries, maxRetries);
}
